<template>
  <!-- Full width YouTube video embed at top -->
  <div class="video-container">
    <iframe src="https://www.youtube.com/embed/5antKaomWDk?si=-B91AbtZUTi4vyXX" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    <br />
    <a href="https://youtube.com/shorts/WyC3pd2XP7o?si=-S0OIQvV5nI9qo2c" target="_blank">Watch YouTube Short</a>
  </div>
  <div :class="{'dark-mode': isDarkMode, 'app-container': true, 'auto-mode': autoThemeMode, 'focus-mode': showFocusMode}">
    <nav :class="{'scrolled': hasScrolled}">
      <button @click="toggleDarkMode">{{ isDarkMode ? 'Light Mode' : 'Dark Mode' }}</button>
      <button @click="toggleAutoTheme">Auto Theme: {{ autoThemeMode ? 'On' : 'Off' }}</button>
      <button @click="toggleFocusMode">{{ showFocusMode ? 'Exit Focus Mode' : 'Focus Mode' }}</button>
      <a href="#home" v-if="!showFocusMode">Home</a>
      <a href="#about" v-if="!showFocusMode">About</a>
      <a href="#links" v-if="!showFocusMode">Links</a>
      <a href="#technical-vision" v-if="!showFocusMode">Technical Vision</a>
      <a href="#pdf-structure" v-if="!showFocusMode">PDF Structure & Versions</a>
      <a href="#pdf-dom-explorer">PDF DOM Explorer</a>
      <a href="#ai-methodology" v-if="!showFocusMode">AI Methodology</a>
      <a href="#detailed-explanation" v-if="!showFocusMode">Detailed Explanation</a>
      <a href="#extended-pdfdom" v-if="!showFocusMode">Extended PDF DOM & C++ Engine</a>
      <a href="#contact" v-if="!showFocusMode">Contact</a>
    </nav>

    <main>
      <section id="home" v-if="!showFocusMode">
        <details open @toggle="onSectionToggle($event, 'home')">
          <summary>Welcome to PDFSage</summary>
          <span v-if="sectionCountdowns.home > 0">{{ sectionCountdowns.home }}s left</span>
          <h1>Welcome to PDFSage</h1>
          <p>
            PDFSage was founded on the fact that Adobe AcrobatPro is currently a monopoly in the PDF editing, and thus also PDF market. For $10 per month, you get poor UI mobile AcrobatPro on one iOS or Android platform only. After just 24 hours in building the PDF parsing, rendering, and editing engine, Bo Shang has gotten parsing and editing almost fully working for PDF versions 1.4 and 1.7.
          </p>
        </details>
      </section>

      <section id="about" v-if="!showFocusMode">
        <details open @toggle="onSectionToggle($event, 'about')">
          <summary>About PDFSage</summary>
          <span v-if="sectionCountdowns.about > 0">{{ sectionCountdowns.about }}s left</span>
          <h2>About PDFSage</h2>
          <p>
PDFSage aims to channel ADHD and distraction into the PDF engine only, dropping all other distractions, and bring the PDFSage engine to all platforms ASAP to compete with Adobe's monopoly.
          </p>
        </details>
      </section>

      <section id="links" v-if="!showFocusMode">
        <details open>
          <summary>Links</summary>
          <h2>Links</h2>
          <ul>
            <li><a href="https://pdfsage.com" target="_blank">PDFSage.com</a></li>
            <li><a href="https://pdfsage.net" target="_blank">DFSage.net</a></li>
            <li><a href="https://erosolar.net" target="_blank">Erosolar.net</a></li>
            <li><a href="https://erosolar.online" target="_blank">Erosolar.online</a></li>
          </ul>
        </details>
      </section>

      <div class="section" v-if="!showFocusMode">
        <details open>
          <summary>Portfolio</summary>
          <h2>Portfolio</h2>
          <ul class="link-list">
            <li>
              <a href="https://www.pdfsage.com" target="_blank" rel="noreferrer">
                PDFSage.com
              </a>
            </li>
            <li>
              <a href="https://www.pdfsage.net" target="_blank" rel="noreferrer">
                PDFSage.net
              </a>
            </li>
            <li>
              <a href="https://erosolar.net" target="_blank" rel="noreferrer">
                Erosolar.net
              </a>
            </li>
            <li>
              <a href="https://www.erosolar.online" target="_blank" rel="noreferrer">
                Erosolar.online
              </a>
            </li>
            <li>
              <a
                href="https://apps.apple.com/us/app/pdfsage-device-tools/id6738795431"
                target="_blank"
                rel="noreferrer"
              >
                PDFSage iOS Device Tools
              </a>
            </li>
            <li>
              <a
                href="https://apps.apple.com/us/app/pdfsage-algorithmic-ai/id6741389058"
                target="_blank"
                rel="noreferrer"
              >
                PDFSage iOS AlgorithmicAI
              </a>
            </li>
            <li>
              <a
                href="https://apps.apple.com/us/app/genai-software-eng-guide/id6741058482"
                target="_blank"
                rel="noreferrer"
              >
                iOS GenAI Software Eng Guide
              </a>
            </li>
            <li>
              <a
                href="https://apps.apple.com/us/app/pdfsage-sage-engine-coming/id6739861453"
                target="_blank"
                rel="noreferrer"
              >
                iOS PDFSage
              </a>
            </li>
            <li>
              <a
                href="https://apps.apple.com/us/app/pdfsage-connect-4/id6741052119"
                target="_blank"
                rel="noreferrer"
              >
                iOS Connect 4
              </a>
            </li>
            <li>
              <a
                href="https://testflight.apple.com/join/f8Wk24jG"
                target="_blank"
                rel="noreferrer"
              >
                TestFlight: Device Tools
              </a>
            </li>
            <li>
              <a
                href="https://testflight.apple.com/join/AqEVYS8D"
                target="_blank"
                rel="noreferrer"
              >
                TestFlight: AlgorithmicAI Gaming
              </a>
            </li>
            <li>
              <a
                href="https://testflight.apple.com/join/cWkBXd9u"
                target="_blank"
                rel="noreferrer"
              >
                TestFlight: GenAI Software Eng Guide
              </a>
            </li>
            <li>
              <a
                href="https://testflight.apple.com/join/mc5Jn57d"
                target="_blank"
                rel="noreferrer"
              >
                TestFlight: PDFSage
              </a>
            </li>
          </ul>
        </details>
      </div>

      <section id="technical-vision" class="section" v-if="!showFocusMode">
        <details open>
          <summary>Technical Vision</summary>
          <h2>Technical Vision</h2>
          <p>
            PDFSage is developing a PDF engine that integrates specialized AI technologies for parsing, rendering, editing, and automation. Key capabilities include:
          </p>
          <ul>
            <li>High-precision PDF DOM parsing with malformed document recovery</li>
            <li>Structured rendering engine for real-time manipulations</li>
            <li>Seamless in-document editing powered by text detection and reflow</li>
            <li>Multi-threaded architecture for tasks like annotation, form processing, and data extraction</li>
            <li>Integration of AI for context-aware text editing</li>
            <li>Workflow automation for batch document processing</li>
          </ul>
          <button @click="toggleAdvancedDetails">
            {{ showAdvancedDetails ? 'Hide Additional AI Details' : 'Show Additional AI Details' }}
          </button>
          <div v-if="showAdvancedDetails" class="ai-details">
            <p>Future enhancements focus on:</p>
            <ul>
              <li>AI-based PDF structure interpretation for efficient editing and layout preservation</li>
              <li>Object-level classification to streamline merging, splitting, and rearranging PDFs</li>
              <li>Automated tagging and accessibility compliance via DOM-based analysis</li>
              <li>Handwriting recognition modules for markup conversion into editable text</li>
              <li>AI-driven transformations for advanced text reflow and layering</li>
            </ul>
          </div>
        </details>
      </section>

      <section id="pdf-structure" class="section" v-if="!showFocusMode">
        <details open>
          <summary>PDF Structure & Versions</summary>
          <h2>PDF Structure & Versions</h2>
          <p>
            The PDF file format comprises objects, cross-reference tables, trailers, and streams. Pages reference fonts, images, and other resources through these objects. Dictionaries store metadata, allowing flexible modification without rewriting the entire file.
          </p>
          <ul>
            <li><strong>PDF 1.3</strong> – Introduced incremental updates and new compression features.</li>
            <li><strong>PDF 1.4</strong> – Added transparency and enhancements for interactive forms.</li>
            <li><strong>PDF 1.5</strong> – Introduced object streams and compressed cross-reference tables.</li>
            <li><strong>PDF 1.6</strong> – Enhanced encryption and 3D support.</li>
            <li><strong>PDF 1.7</strong> – Standardized as ISO 32000-1, improved metadata.</li>
            <li><strong>PDF 2.0</strong> – ISO 32000-2, clarifications, security updates, and expanded annotations.</li>
          </ul>
        </details>
      </section>

      <section id="pdf-dom-explorer" class="section">
        <details open>
          <summary>PDF DOM Explorer</summary>
          <p>Select an object to inspect its references, streams, and dictionaries:</p>

          <div class="dom-explorer-controls">
            <input
              v-model="searchQuery"
              type="text"
              placeholder="Search by Type or ID..."
              @input="filterObjects"
            />
            <input
              v-model="referenceQuery"
              type="text"
              placeholder="Search in References..."
              @input="filterObjects"
            />
            <button @click="resetSearch">Reset Search</button>
            <span>Showing {{ filteredPdfObjects.length }} of {{ pdfObjects.length }} objects</span>
            <button @click="toggleReflowMode">{{ reflowEditingMode ? 'Hide Reflow Editor' : 'Show Reflow Editor' }}</button>
            <button @click="toggleStatsView">{{ showStats ? 'Hide Stats' : 'Show Stats' }}</button>
            <button @click="toggleGroupByType">{{ groupByType ? 'Ungroup' : 'Group By Type' }}</button>
            <button @click="toggleExtraSearch">{{ showExtraSearch ? 'Hide Adv Filter' : 'Advanced Filter' }}</button>
            <button @click="toggleRelationshipGraph">{{ showRelationshipGraph ? 'Hide Graph' : 'Show Graph' }}</button>
            <button @click="toggleMinimap">{{ showMinimap ? 'Hide MiniMap' : 'Show MiniMap' }}</button>
            <button @click="toggleLivePreview">{{ showLivePreview ? 'Hide Live Preview' : 'Live Preview' }}</button>
          </div>

          <div class="advanced-search" v-if="showExtraSearch">
            <label for="dictKeyQuery">Filter by Dictionary Key:</label>
            <input id="dictKeyQuery" v-model="dictKeyQuery" placeholder="e.g. Subtype" @input="filterObjects" />
            <label for="streamSearch">Filter by Stream Data:</label>
            <input id="streamSearch" v-model="streamDataQuery" placeholder="e.g. Font stream" @input="filterObjects" />
            <label for="typeExclude">Exclude Type:</label>
            <input id="typeExclude" v-model="excludedType" placeholder="e.g. Image" @input="filterObjects" />
            <label for="metadataKeywordQuery">Metadata Keyword:</label>
            <input
              id="metadataKeywordQuery"
              v-model="metadataKeywordQuery"
              placeholder="e.g. 'rendering'"
              @input="filterObjects"
            />
            <label for="tagSearch">Filter by Tag:</label>
            <input
              id="tagSearch"
              v-model="tagSearch"
              placeholder="e.g. 'bookmarks'"
              @input="filterObjects"
            />
            <label>
              <input type="checkbox" v-model="additionalSearchOptions.useRegex" @change="filterObjects" />
              Use Regex
            </label>
            <label for="dateRangeStart">Start Date:</label>
            <input
              id="dateRangeStart"
              type="date"
              v-model="additionalSearchOptions.dateRange.start"
              @change="filterObjects"
            />
            <label for="dateRangeEnd">End Date:</label>
            <input
              id="dateRangeEnd"
              type="date"
              v-model="additionalSearchOptions.dateRange.end"
              @change="filterObjects"
            />
            <label for="encryptionFilter">Encryption:</label>
            <select id="encryptionFilter" v-model="encryptionFilter" @change="filterObjects">
              <option value="">Any</option>
              <option value="None">None</option>
              <option value="AES256">AES256</option>
              <option value="RC4">RC4</option>
            </select>
          </div>

          <div v-if="showStats" class="stats-container">
            <h4>Object Stats By Type</h4>
            <ul>
              <li v-for="(count, type) in statsByType" :key="type">
                {{ type }}: {{ count }}
              </li>
            </ul>
            <div class="bar-chart">
              <div
                v-for="(count, type) in statsByType"
                :key="type"
                class="bar"
                :style="{ height: (count * 20) + 'px' }"
              >
                {{ type }}
              </div>
            </div>
          </div>

          <div v-if="pinnedObjects.length" class="pinned-objects">
            <h4>Pinned Objects</h4>
            <table>
              <thead>
                <tr>
                  <th>Object ID</th>
                  <th>Type</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="p in pinnedObjects" :key="p.id">
                  <td>{{ p.id }}</td>
                  <td>{{ p.type }}</td>
                  <td>
                    <button @click="unpinObject(p.id)">Unpin</button>
                    <button @click="inspectObject(p)">Inspect</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <transition-group name="row-fade" tag="div" class="dom-explorer">
            <table v-if="displayedObjects.length" key="table">
              <thead>
                <tr>
                  <th>Select</th>
                  <th @click="sortBy('id')">Object ID</th>
                  <th @click="sortBy('type')">Type</th>
                  <th>References</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <transition-group name="items-fade" tag="tbody">
                  <tr
                    v-for="item in displayedObjects"
                    :key="item.id"
                    :class="{
                      'selected': selectedObject && selectedObject.id === item.id,
                      'type-page': item.type === 'Page',
                      'type-font': item.type === 'Font',
                      'type-annotation': item.type === 'Annotation',
                      'type-image': item.type === 'Image',
                      'type-outline': item.type === 'Outline',
                      'type-form': item.type === 'Form'
                    }"
                    draggable="true"
                    @dragstart="handleDragStart(item.id)"
                    @dragover.prevent="handleDragOver(item.id)"
                    @drop.prevent="handleDrop(item.id)"
                  >
                    <td>
                      <input
                        type="checkbox"
                        v-model="selectedObjects"
                        :value="item.id"
                      />
                    </td>
                    <td v-html="highlightMatch(item.id.toString())"></td>
                    <td v-html="highlightMatch(item.type)"></td>
                    <td>
                      <span
                        class="ref"
                        v-for="(ref, idx) in item.references"
                        :key="idx"
                        v-html="highlightReference(ref)"
                      ></span>
                    </td>
                    <td>
                      <button @click="inspectObject(item)">Inspect</button>
                      <button @click="editObject(item)">Edit</button>
                      <button @click="aiClassifyType(item)">AI Classify</button>
                      <button @click="compareCandidate(item)">Compare</button>
                      <button @click="pinObject(item)">Pin</button>
                      <button v-if="showLivePreview" @click="quickPreview(item)">Preview</button>
                    </td>
                  </tr>
                </transition-group>
              </tbody>
            </table>
            <p v-else key="no-data">No objects found</p>
          </transition-group>

          <div class="bulk-actions" v-if="selectedObjects.length">
            <p>Selected: {{ selectedObjects }}</p>
            <button @click="selectAllObjects">Select All</button>
            <button @click="deselectAllObjects">Deselect All</button>
            <button @click="deleteSelectedObjects">Delete Selected</button>
            <button @click="mergeSelectedObjects">Merge Selected (Demo)</button>
            <button @click="exportSelectedObjectsAsJSON">Export as JSON</button>
            <button @click="importSelectedObjectsJSON">Import from JSON</button>
            <button @click="saveVersion">Save Version</button>
            <label for="oldRef" style="margin-left:10px;">Old Ref:</label>
            <input id="oldRef" v-model="oldRef" style="width:100px;" />
            <label for="newRef">New Ref:</label>
            <input id="newRef" v-model="newRef" style="width:100px;" />
            <button @click="renameSelectedReferences">Rename Selected Refs</button>
            <button @click="batchRenameDictKeys">Batch Rename DictKeys</button>
            <button @click="pinSelectedObjects">Pin Selected</button>
            <button @click="aiBatchReclassify">AI Batch Reclassify</button>
          </div>

          <div class="pagination">
            <button
              @click="prevPage"
              :disabled="currentPage === 1"
            >
              Prev
            </button>
            <span>Page {{ currentPage }} / {{ totalPages }}</span>
            <button
              @click="nextPage"
              :disabled="currentPage === totalPages"
            >
              Next
            </button>
            <button @click="undo" :disabled="undoStack.length === 0">Undo Last Change</button>
            <button @click="scrollToTop">Scroll to Top</button>
            <button @click="scrollToBottom">Scroll to Bottom</button>
            <button @click="togglePDFPreview">{{ showPDFPreview ? 'Hide PDF Preview' : 'Preview PDF' }}</button>
          </div>

          <div v-if="selectedObject" class="object-details">
            <h3>Object Details (ID: {{ selectedObject.id }})</h3>
            <p>Type: {{ selectedObject.type }}</p>
            <p>Dictionary Keys:</p>
            <ul>
              <li v-for="(key, index) in selectedObject.dictKeys" :key="index">
                {{ key }}
                <button @click="removeDictKey(index)">Remove</button>
              </li>
            </ul>
            <input v-model="newDictKey" placeholder="New Dictionary Key" />
            <button @click="addDictKey">Add Key</button>
            <p>Stream Data:</p>
            <textarea v-model="selectedObject.streamData" rows="5"></textarea>
            <p>Metadata:</p>
            <p>Creation Date: <input v-model="selectedObject.metadata.creationDate" /></p>
            <p>Author: <input v-model="selectedObject.metadata.author" /></p>
            <p>Keywords:</p>
            <ul>
              <li v-for="(kw, idx) in selectedObject.metadata.keywords" :key="idx">
                {{ kw }}
                <button @click="removeMetadataKeyword(idx)">Remove</button>
              </li>
            </ul>
            <input v-model="newMetadataKeyword" placeholder="New Keyword" />
            <button @click="addMetadataKeyword">Add Keyword</button>
            <p>Encryption: {{ selectedObject.encryption || 'None' }}</p>
            <div class="object-actions">
              <button @click="saveObjectChanges">Save Changes</button>
              <button @click="cancelObjectEdit">Cancel</button>
              <button @click="toggleAISummary">{{ showAISummary ? 'Hide AI Summary' : 'AI Summary' }}</button>
              <button @click="moveObjectUp(selectedObject.id)">Move Up</button>
              <button @click="moveObjectDown(selectedObject.id)">Move Down</button>
            </div>
            <div class="ai-summary" v-if="showAISummary">
              <button @click="generateAISummary">Generate Summary</button>
              <p v-if="aiSummary">{{ aiSummary }}</p>
            </div>
          </div>

          <div class="dom-tree" v-if="expandedStructure.length">
            <h3>DOM Tree View</h3>
            <div class="dom-tree-controls">
              <button @click="expandAllNodes">Expand All</button>
              <button @click="collapseAllNodes">Collapse All</button>
            </div>
            <ul>
              <li v-for="node in expandedStructure" :key="node.id">
                <span @click="toggleNode(node)">
                  {{ node.type }} (ID: {{ node.id }})
                  <span v-if="node.children && node.children.length">
                    [ {{ node.expanded ? 'Collapse' : 'Expand' }} ]
                  </span>
                </span>
                <transition name="tree-slide">
                  <ul v-if="node.expanded && node.children && node.children.length">
                    <li v-for="child in node.children" :key="child.id">
                      {{ child.type }} (ID: {{ child.id }})
                    </li>
                  </ul>
                </transition>
              </li>
            </ul>
          </div>

          <div v-if="reflowEditingMode" class="reflow-editor">
            <h3>Reflow Editing (AI-Assisted)</h3>
            <p>Here you can edit text as if it were a standard word processor. The system reflows paragraphs around images and annotations, guided by AI suggestions.</p>
            <div class="in-render-editing">
              <textarea
                v-model="inRenderEditBuffer"
                rows="8"
                placeholder="Type your PDF text edits here..."
              ></textarea>
              <button @click="applyReflowEdits">Apply Edits</button>
              <div class="copilot-suggestions" v-if="copilotSuggestions.length">
                <h4>Copilot Suggestions</h4>
                <ul>
                  <li v-for="(sug, idx) in copilotSuggestions" :key="idx">
                    {{ sug }}
                    <button @click="acceptSuggestion(sug)">Accept</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div v-if="showRelationshipGraph" class="relationship-graph">
            <h3>Relationship Graph (Demo)</h3>
            <button @click="toggleGraphLayout">Layout: {{ graphLayout }}</button>
            <button @click="toggleGraphDimension">Dimension: {{ graphDimension }}</button>
            <div class="graph-container">
              <ul>
                <li v-for="obj in pdfObjects" :key="obj.id">
                  <strong>{{ obj.type }} (ID: {{ obj.id }})</strong>
                  <ul>
                    <li v-for="(ref, idx) in obj.references" :key="idx">{{ ref }}</li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>

          <div v-if="compareObjects.length" class="compare-panel">
            <h3>Compare Objects</h3>
            <p v-if="compareObjects.length === 1">Select another object to compare.</p>
            <p v-else>Comparing object {{ compareObjects[0].id }} and {{ compareObjects[1].id }}</p>
            <div v-if="compareObjects.length === 2">
              <button @click="clearCompare">Clear Compare</button>
              <div class="compare-diffs">
                <h4>Type</h4>
                <p>{{ compareObjects[0].type }} vs {{ compareObjects[1].type }}</p>
                <h4>References</h4>
                <p>{{ compareObjects[0].references.join(', ') }} vs {{ compareObjects[1].references.join(', ') }}</p>
                <h4>Dictionary Keys</h4>
                <p>{{ compareObjects[0].dictKeys.join(', ') }} vs {{ compareObjects[1].dictKeys.join(', ') }}</p>
              </div>
            </div>
          </div>

          <div class="versions-panel" v-if="versions.length">
            <h3>Version History</h3>
            <ul>
              <li v-for="(ver, index) in versions" :key="index">
                Version {{ index + 1 }} ({{ ver.timestamp }})
                <button @click="revertVersion(index)">Revert</button>
              </li>
            </ul>
          </div>

          <div
            class="pdf-preview-container"
            v-if="showPDFPreview"
          >
            <h3>PDF Preview (Demo)</h3>
            <p>Rendering Page {{ pdfPreviewPage }}</p>
            <button @click="prevPreviewPage" :disabled="pdfPreviewPage === 1">Prev Page</button>
            <button @click="nextPreviewPage" :disabled="pdfPreviewPage === maxPreviewPages">Next Page</button>
            <div class="preview-canvas">
              <p>Preview canvas area for page {{ pdfPreviewPage }} ...</p>
            </div>
          </div>
        </details>
      </section>

      <section v-if="!showFocusMode" id="ai-methodology" class="section">
        <details open>
          <summary>AI Methodology</summary>
          <h2>AI Methodology for Next-Generation PDF Editing</h2>
          <p>
            Our primary objective is to make PDF editing as intuitive as editing a plain-text or word-processing document. This involves bridging the intricate structures found in PDF files with AI-driven features that recognize the semantics of text, images, and layout.
          </p>
          <p>
            1. <strong>Advanced Layout Analysis</strong>: We employ a multi-stage layout processor that detects columns, tables, headers, footers, and other structural elements.
          </p>
          <p>
            2. <strong>Context-Aware Text Editing</strong>: Our engine uses language models to detect semantic boundaries, paragraphs, and contextual meaning.
          </p>
          <p>
            3. <strong>Semantic Object Detection</strong>: We integrate computer vision techniques to recognize images, shapes, or vector graphics in a PDF.
          </p>
          <p>
            4. <strong>Text Reflow Engine</strong>: A specialized reflow subsystem dynamically adjusts paragraphs and text blocks as edits occur.
          </p>
          <p>
            5. <strong>Incremental Update Strategy</strong>: Rather than rewriting entire PDFs, we leverage incremental updates.
          </p>
          <p>
            6. <strong>Metadata and Tagging</strong>: Our system extracts and maintains rich metadata about fonts, colors, annotations, and accessibility tags.
          </p>
          <p>
            7. <strong>Adaptive Document Conversion</strong>: When converting from other formats or scanning in documents, the AI engine attempts to reconstruct logical structure.
          </p>
          <p>
            8. <strong>Research Backbone (2023-2024)</strong>: The foundation of PDFSage includes ongoing research into NLP-driven layout analysis and improved vector-graphic manipulations.
          </p>
        </details>
      </section>

      <section v-if="!showFocusMode" id="detailed-explanation" class="section">
        <details open>
          <summary>Detailed Explanation</summary>
          <h2>Detailed Explanation of Parsing, Rendering, and In-Render Editing</h2>
          <p>
            <strong>1. Parsing Stage</strong>: PDFSage reads the PDF file structure and checks for corruption or inconsistencies.
          </p>
          <p>
            <strong>2. Building the PDF DOM</strong>: Once objects are identified, we assemble them into a Document Object Model-like structure.
          </p>
          <p>
            <strong>3. Rendering Engine</strong>: The rendering engine interprets the PDF DOM. It lays out text, images, and vector graphics.
          </p>
          <p>
            <strong>4. Word-Processor-Like In-Render Editing</strong>: PDFSage introduces a reflow mode. When enabled, the user can edit text blocks in a more fluid way.
          </p>
          <p>
            <strong>5. AI-Assisted Reflow with Copilot Support</strong>: AI assists real-time editing by suggesting synonyms or corrections.
          </p>
          <p>
            <strong>6. Incremental Updates</strong>: We store edits in separate object streams to avoid regenerating the entire file.
          </p>
          <p>
            <strong>7. Conclusion</strong>: Our system combines robust performance, deep editing capabilities, and intuitive workflows.
          </p>
        </details>
      </section>

      <section v-if="!showFocusMode" id="extended-pdfdom" class="section">
        <details open>
          <summary>Extended PDF DOM & C++ PDFSage Engine</summary>
          <h2>Extended PDF DOM & C++ PDFSage Engine Architecture</h2>
          <p>
            The <strong>PDF DOM</strong> serves as the central component of PDFSage.
          </p>
          <ul>
            <li><strong>Nodes and Properties</strong>: Each node includes base properties and optional references to streams.</li>
            <li><strong>Hierarchical Structure</strong>: Pages contain references to fonts, images, annotations, and other resources.</li>
            <li><strong>Parallel Processing</strong>: For large PDFs, we break down rendering tasks by page or object cluster.</li>
            <li><strong>Incremental Updates</strong>: The DOM can mark individual nodes as changed for efficient saves.</li>
          </ul>
          <p>
            <strong>The PDFSage C++ Engine</strong> is designed to run on multiple platforms.
          </p>
          <ul>
            <li><strong>Modular Architecture</strong>: The engine is split into modules for parsing, rendering, editing, AI, and more.</li>
            <li><strong>Dependency Management</strong>: We rely on modern C++ standards and manage third-party libraries carefully.</li>
            <li><strong>Rendering Pipeline</strong>: The engine constructs display lists from the DOM.</li>
            <li><strong>AI Integration Hooks</strong>: Specialized hooks allow the AI layer to inspect the DOM or partially rendered data.</li>
            <li><strong>Thread-Safe DOM</strong>: The DOM includes atomic reference counters and concurrency-safe containers.</li>
            <li><strong>Incremental File Updates</strong>: When saving, only the modified objects are rewritten.</li>
            <li><strong>Platform-Specific Optimizations</strong>: On iOS, the engine leverages Metal for hardware-accelerated rendering.</li>
          </ul>
          <p>
            <strong>Memory Management and Object References</strong>: Each PDF object is reference-counted.
          </p>
          <p>
            <strong>Error Handling and Corruption Recovery</strong>: The engine logs anomalies and attempts to recover from partial corruption.
          </p>
          <p>
            <strong>Handling Advanced PDF Features</strong>: We support form fields, embedded files, multimedia annotations, and advanced encryption.
          </p>
          <p>
            <strong>Layers and Transparency Groups</strong>: The engine manages optional content groups and transparency layers.
          </p>
          <p>
            <strong>Partial Download and Linearized PDF Handling</strong>: For linearized PDFs, pages can render before the entire file is downloaded.
          </p>
          <p>
            <strong>Build Process</strong> (simplified example using CMake):
          </p>
          <pre><code class="language-bash">
mkdir build
cd build
cmake -DCMAKE_BUILD_TYPE=Release ..
make -j8
          </code></pre>
          <p>
            <strong>AI for Reflow Editing</strong>: Our AI components evaluate text layout in real time.
          </p>
          <p>
            <strong>Additional C++ Engine Insights</strong>: We profile memory usage and CPU load across different workflows.
          </p>
        </details>
      </section>

      <section v-if="!showFocusMode" id="contact" class="section">
        <details open>
          <summary>Contact Information</summary>
          <h2>Contact Information</h2>
          <p>Phone: +1 781-999-4101</p>
          <p>Email: bo@shang.software</p>
          <p>Email: b0sh4ng@gmail.com</p>
          <p>Email: bo@pdfsage.com</p>
          <p>Email: bo@pdfsage.xyz</p>
        </details>
      </section>
    </main>

    <div v-if="showMinimap" class="minimap">
      <h4>MiniMap</h4>
      <ul>
        <li
          v-for="(obj, index) in pdfObjects"
          :key="obj.id"
          :class="{
            'map-page': obj.type === 'Page',
            'map-font': obj.type === 'Font',
            'map-annotation': obj.type === 'Annotation',
            'map-image': obj.type === 'Image',
            'map-outline': obj.type === 'Outline',
            'map-form': obj.type === 'Form'
          }"
        >
          ID {{ obj.id }} - {{ obj.type }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      showAdvancedDetails: false,
      isDarkMode: false,
      autoThemeMode: false,
      reflowEditingMode: false,
      hasScrolled: false,
      showStats: false,
      groupByType: false,
      showExtraSearch: false,
      showAISummary: false,
      aiSummary: '',
      showRelationshipGraph: false,
      searchQuery: '',
      referenceQuery: '',
      dictKeyQuery: '',
      streamDataQuery: '',
      excludedType: '',
      metadataKeywordQuery: '',
      tagSearch: '',
      oldRef: '',
      newRef: '',
      undoStack: [],
      additionalSearchOptions: {
        useRegex: false,
        dateRange: {
          start: '',
          end: ''
        }
      },
      encryptionFilter: '',
      graphLayout: 'hierarchical',
      graphDimension: '2D',
      showPDFPreview: false,
      pdfPreviewPage: 1,
      maxPreviewPages: 3,
      pdfObjects: [
        {
          id: 1,
          type: 'Page',
          references: ['Fonts', 'Images'],
          dictKeys: ['Type', 'MediaBox'],
          streamData: 'Page content stream...',
          metadata: {
            creationDate: '2025-01-10',
            author: 'Bo Shang',
            keywords: ['page', 'rendering'],
            tags: ['core', 'demo']
          },
          encryption: 'None'
        },
        {
          id: 2,
          type: 'Font',
          references: ['Encoding'],
          dictKeys: ['BaseFont', 'Subtype'],
          streamData: 'Font stream data...',
          metadata: {
            creationDate: '2025-01-11',
            author: 'System',
            keywords: ['font', 'typeface'],
            tags: ['fonts']
          },
          encryption: 'None'
        },
        {
          id: 3,
          type: 'Annotation',
          references: ['Page 1'],
          dictKeys: ['Subtype', 'Rect'],
          streamData: 'Annotation data...',
          metadata: {
            creationDate: '2025-01-12',
            author: 'PDFSage',
            keywords: ['annotation'],
            tags: ['notes']
          },
          encryption: 'None'
        },
        {
          id: 4,
          type: 'Page',
          references: ['Fonts', 'Page 3'],
          dictKeys: ['Type', 'CropBox'],
          streamData: 'Another page content stream...',
          metadata: {
            creationDate: '2025-01-13',
            author: 'Bo Shang',
            keywords: ['page', 'graphics'],
            tags: []
          },
          encryption: 'None'
        },
        {
          id: 5,
          type: 'Image',
          references: [],
          dictKeys: ['Width', 'Height', 'ColorSpace'],
          streamData: 'Binary image data...',
          metadata: {
            creationDate: '2025-01-14',
            author: 'AssetGen',
            keywords: ['image', 'binary'],
            tags: ['assets']
          },
          encryption: 'None'
        },
        {
          id: 6,
          type: 'Outline',
          references: ['Parent'],
          dictKeys: ['Title', 'Dest'],
          streamData: 'Bookmark outline data...',
          metadata: {
            creationDate: '2025-01-15',
            author: 'PDFSage',
            keywords: ['outline', 'bookmarks'],
            tags: ['bookmarks']
          },
          encryption: 'None'
        },
        {
          id: 7,
          type: 'Form',
          references: ['Page 1'],
          dictKeys: ['Fields', 'DefaultAppearance'],
          streamData: 'Form data...',
          metadata: {
            creationDate: '2025-01-16',
            author: 'PDFSage',
            keywords: ['form'],
            tags: ['interactive']
          },
          encryption: 'None'
        },
        {
          id: 8,
          type: 'EmbeddedFile',
          references: ['FileSpec'],
          dictKeys: ['Type', 'Subtype', 'Length'],
          streamData: 'Some embedded file stream data...',
          metadata: {
            creationDate: '2025-01-17',
            author: 'DocumentSystem',
            keywords: ['embedded', 'attachments'],
            tags: ['attachments']
          },
          encryption: 'AES256'
        },
        {
          id: 9,
          type: 'JavaScript',
          references: ['LaunchAction'],
          dictKeys: ['S', 'JS'],
          streamData: 'console.log("Hello from PDF JavaScript!")',
          metadata: {
            creationDate: '2025-01-18',
            author: 'PDFSage',
            keywords: ['script', 'javascript'],
            tags: []
          },
          encryption: 'RC4'
        },
        {
          id: 10,
          type: 'XObject',
          references: ['Images', 'Form'],
          dictKeys: ['Subtype', 'BBox'],
          streamData: 'Form XObject data...',
          metadata: {
            creationDate: '2025-01-19',
            author: 'Renderer',
            keywords: ['xobject', 'layers'],
            tags: []
          },
          encryption: 'None'
        },
        {
          id: 11,
          type: 'Shading',
          references: [],
          dictKeys: ['ShadingType', 'ColorSpace'],
          streamData: 'Gradient shading data...',
          metadata: {
            creationDate: '2025-01-20',
            author: 'GraphicsLib',
            keywords: ['gradient', 'fill'],
            tags: ['graphics']
          },
          encryption: 'None'
        }
      ],
      filteredPdfObjects: [],
      pinnedObjects: [],
      selectedObject: null,
      selectedObjects: [],
      sortKey: '',
      sortAsc: true,
      inRenderEditBuffer: '',
      copilotSuggestions: [
        'Rephrase the sentence for clarity',
        'Remove unnecessary whitespace',
        'Fix grammar issues'
      ],
      currentPage: 1,
      pageSize: 3,
      expandedStructure: [
        {
          id: 1,
          type: 'Page',
          children: [
            { id: 2, type: 'Font', children: [] },
            { id: 3, type: 'Annotation', children: [] }
          ],
          expanded: false
        },
        {
          id: 4,
          type: 'Page',
          children: [
            { id: 5, type: 'Image', children: [] }
          ],
          expanded: false
        },
        {
          id: 6,
          type: 'Outline',
          children: [],
          expanded: false
        }
      ],
      compareObjects: [],
      versions: [],
      newDictKey: '',
      newMetadataKeyword: '',
      showFocusMode: false,
      showMinimap: false,
      showLivePreview: false,
      draggingObjectId: null,
      sectionTimers: {
        preface: null,
        analysis: null,
        groundRules: null,
        progress: null,
        home: null,
        about: null,
        corePhilosophy: null
      },
      sectionCountdowns: {
        preface: 0,
        analysis: 0,
        groundRules: 0,
        progress: 0,
        home: 0,
        about: 0,
        corePhilosophy: 0
      }
    }
  },
  created() {
    const savedDarkMode = localStorage.getItem('isDarkMode')
    if (savedDarkMode !== null) {
      this.isDarkMode = JSON.parse(savedDarkMode)
    }
    this.filteredPdfObjects = this.pdfObjects
    window.addEventListener('scroll', this.handleScroll)
    this.detectSystemDarkMode()
    window.addEventListener('keydown', this.handleKeyShortcuts)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('keydown', this.handleKeyShortcuts)
  },
  computed: {
    totalPages() {
      return Math.ceil(this.filteredPdfObjects.length / this.pageSize)
    },
    paginatedObjects() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.filteredPdfObjects.slice(start, end)
    },
    statsByType() {
      const counts = {}
      this.pdfObjects.forEach(obj => {
        if (!counts[obj.type]) counts[obj.type] = 0
        counts[obj.type]++
      })
      return counts
    },
    displayedObjects() {
      if (!this.groupByType) return this.paginatedObjects
      let grouped = {}
      this.paginatedObjects.forEach(obj => {
        if (!grouped[obj.type]) grouped[obj.type] = []
        grouped[obj.type].push(obj)
      })
      let flat = []
      Object.keys(grouped).sort().forEach(type => {
        flat = flat.concat(grouped[type])
      })
      return flat
    }
  },
  methods: {
    onSectionToggle(e, sectionName) {
      if (e.target.open) {
        clearInterval(this.sectionTimers[sectionName])
        this.sectionCountdowns[sectionName] = 60
        this.sectionTimers[sectionName] = setInterval(() => {
          if (this.sectionCountdowns[sectionName] > 0) {
            this.sectionCountdowns[sectionName]--
          } else {
            clearInterval(this.sectionTimers[sectionName])
            e.target.open = false
          }
        }, 1000)
      } else {
        clearInterval(this.sectionTimers[sectionName])
        this.sectionCountdowns[sectionName] = 0
      }
    },
    toggleAdvancedDetails() {
      this.showAdvancedDetails = !this.showAdvancedDetails
    },
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode
      localStorage.setItem('isDarkMode', JSON.stringify(this.isDarkMode))
    },
    toggleAutoTheme() {
      this.autoThemeMode = !this.autoThemeMode
    },
    toggleFocusMode() {
      this.showFocusMode = !this.showFocusMode
    },
    toggleReflowMode() {
      this.reflowEditingMode = !this.reflowEditingMode
    },
    toggleStatsView() {
      this.showStats = !this.showStats
    },
    toggleGroupByType() {
      this.groupByType = !this.groupByType
      this.currentPage = 1
    },
    toggleExtraSearch() {
      this.showExtraSearch = !this.showExtraSearch
    },
    toggleRelationshipGraph() {
      this.showRelationshipGraph = !this.showRelationshipGraph
    },
    toggleMinimap() {
      this.showMinimap = !this.showMinimap
    },
    toggleLivePreview() {
      this.showLivePreview = !this.showLivePreview
    },
    handleScroll() {
      this.hasScrolled = window.scrollY > 0
    },
    detectSystemDarkMode() {
      const darkMediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
      this.isDarkMode = darkMediaQuery.matches
      darkMediaQuery.addEventListener('change', e => {
        if (this.autoThemeMode) {
          this.isDarkMode = e.matches
        }
      })
    },
    handleKeyShortcuts(e) {
      if (e.ctrlKey && e.shiftKey && e.key === 'F') {
        e.preventDefault()
        const searchBox = document.querySelector('input[type="text"]')
        if (searchBox) searchBox.focus()
      }
      if (e.ctrlKey && e.shiftKey && e.key === 'A') {
        e.preventDefault()
        this.selectAllObjects()
      }
      if (e.ctrlKey && e.shiftKey && e.key === 'S') {
        e.preventDefault()
        this.saveVersion()
      }
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    scrollToBottom() {
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })
    },
    toggleGraphLayout() {
      this.graphLayout = this.graphLayout === 'hierarchical' ? 'force-directed' : 'hierarchical'
    },
    toggleGraphDimension() {
      this.graphDimension = this.graphDimension === '2D' ? '3D' : '2D'
    },
    togglePDFPreview() {
      this.showPDFPreview = !this.showPDFPreview
    },
    nextPreviewPage() {
      if (this.pdfPreviewPage < this.maxPreviewPages) {
        this.pdfPreviewPage++
      }
    },
    prevPreviewPage() {
      if (this.pdfPreviewPage > 1) {
        this.pdfPreviewPage--
      }
    },
    inspectObject(item) {
      this.selectedObject = JSON.parse(JSON.stringify(item))
      this.showAISummary = false
      this.aiSummary = ''
    },
    editObject(item) {
      this.selectedObject = JSON.parse(JSON.stringify(item))
      this.showAISummary = false
      this.aiSummary = ''
    },
    pinObject(item) {
      if (!this.pinnedObjects.find(o => o.id === item.id)) {
        this.pinnedObjects.push(JSON.parse(JSON.stringify(item)))
      }
    },
    unpinObject(id) {
      const idx = this.pinnedObjects.findIndex(o => o.id === id)
      if (idx !== -1) {
        this.pinnedObjects.splice(idx, 1)
      }
    },
    pinSelectedObjects() {
      this.selectedObjects.forEach(id => {
        const obj = this.pdfObjects.find(o => o.id === id)
        if (obj && !this.pinnedObjects.find(p => p.id === obj.id)) {
          this.pinnedObjects.push(JSON.parse(JSON.stringify(obj)))
        }
      })
    },
    pushUndoStack() {
      const snapshot = JSON.stringify(this.pdfObjects)
      this.undoStack.push(snapshot)
    },
    undo() {
      if (!this.undoStack.length) return
      const lastState = this.undoStack.pop()
      this.pdfObjects = JSON.parse(lastState)
      this.filterObjects()
      this.selectedObjects = []
    },
    saveObjectChanges() {
      this.pushUndoStack()
      const index = this.pdfObjects.findIndex(obj => obj.id === this.selectedObject.id)
      if (index !== -1) {
        this.pdfObjects.splice(index, 1, JSON.parse(JSON.stringify(this.selectedObject)))
      }
      alert('Object changes saved (demo).')
      this.selectedObject = null
      this.filterObjects()
    },
    cancelObjectEdit() {
      this.selectedObject = null
    },
    filterObjects() {
      const q1 = this.searchQuery.toLowerCase()
      const q2 = this.referenceQuery.toLowerCase()
      const dictQ = this.dictKeyQuery.toLowerCase()
      const streamQ = this.streamDataQuery.toLowerCase()
      const excludeT = this.excludedType.toLowerCase()
      const metaQ = this.metadataKeywordQuery.toLowerCase()
      const tagQ = this.tagSearch.toLowerCase()
      const useRegex = this.additionalSearchOptions.useRegex
      const startDate = this.additionalSearchOptions.dateRange.start
      const endDate = this.additionalSearchOptions.dateRange.end
      const encryptionVal = this.encryptionFilter

      this.filteredPdfObjects = this.pdfObjects.filter(obj => {
        const textMatch = (source, query) => {
          if (!query) return true
          if (useRegex) {
            try {
              const re = new RegExp(query, 'i')
              return re.test(source)
            } catch {
              return false
            }
          }
          return source.includes(query)
        }
        const matchTypeOrId = textMatch(obj.type.toLowerCase(), q1) || textMatch(obj.id.toString(), q1)
        const matchRef = obj.references.some(ref => textMatch(ref.toLowerCase(), q2))
        const matchDictKey = dictQ ? obj.dictKeys.some(k => textMatch(k.toLowerCase(), dictQ)) : true
        const matchStream = textMatch(obj.streamData.toLowerCase(), streamQ)
        const excludeCheck = excludeT ? obj.type.toLowerCase() !== excludeT : true
        const matchMeta = metaQ
          ? obj.metadata.keywords.some(k => textMatch(k.toLowerCase(), metaQ))
          : true
        const matchTag = tagQ
          ? obj.metadata.tags && obj.metadata.tags.some(t => textMatch(t.toLowerCase(), tagQ))
          : true
        let dateCheck = true
        if (startDate || endDate) {
          const objDate = new Date(obj.metadata.creationDate)
          if (startDate) {
            const start = new Date(startDate)
            if (objDate < start) dateCheck = false
          }
          if (endDate) {
            const end = new Date(endDate)
            if (objDate > end) dateCheck = false
          }
        }
        const matchEncryption = encryptionVal
          ? obj.encryption && obj.encryption === encryptionVal
          : true

        return matchTypeOrId &&
          (q2 ? matchRef : true) &&
          matchDictKey &&
          matchStream &&
          excludeCheck &&
          matchMeta &&
          dateCheck &&
          matchTag &&
          matchEncryption
      })
      this.currentPage = 1
    },
    resetSearch() {
      this.searchQuery = ''
      this.referenceQuery = ''
      this.dictKeyQuery = ''
      this.streamDataQuery = ''
      this.excludedType = ''
      this.metadataKeywordQuery = ''
      this.tagSearch = ''
      this.additionalSearchOptions.useRegex = false
      this.additionalSearchOptions.dateRange.start = ''
      this.additionalSearchOptions.dateRange.end = ''
      this.encryptionFilter = ''
      this.filteredPdfObjects = this.pdfObjects
      this.currentPage = 1
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
      }
    },
    toggleNode(node) {
      node.expanded = !node.expanded
    },
    applyReflowEdits() {
      alert('Reflow edits applied (demo).')
      this.inRenderEditBuffer = ''
    },
    acceptSuggestion(sug) {
      this.inRenderEditBuffer += '\n' + sug
    },
    sortBy(key) {
      if (this.sortKey === key) {
        this.sortAsc = !this.sortAsc
      } else {
        this.sortAsc = true
        this.sortKey = key
      }
      this.filteredPdfObjects.sort((a, b) => {
        if (a[key] < b[key]) return this.sortAsc ? -1 : 1
        if (a[key] > b[key]) return this.sortAsc ? 1 : -1
        return 0
      })
      this.currentPage = 1
    },
    highlightMatch(text) {
      const query = this.searchQuery.trim()
      if (!query || this.additionalSearchOptions.useRegex) return text
      const regex = new RegExp(`(${query})`, 'gi')
      return text.replace(regex, '<mark>$1</mark>')
    },
    highlightReference(ref) {
      const query = this.referenceQuery.trim()
      if (!query || this.additionalSearchOptions.useRegex) return ref
      const regex = new RegExp(`(${query})`, 'gi')
      return ref.replace(regex, '<mark>$1</mark>')
    },
    addDictKey() {
      if (!this.newDictKey.trim()) return
      if (!this.selectedObject.dictKeys.includes(this.newDictKey.trim())) {
        this.selectedObject.dictKeys.push(this.newDictKey.trim())
      }
      this.newDictKey = ''
    },
    removeDictKey(index) {
      this.selectedObject.dictKeys.splice(index, 1)
    },
    addMetadataKeyword() {
      if (!this.newMetadataKeyword.trim()) return
      if (!this.selectedObject.metadata.keywords.includes(this.newMetadataKeyword.trim())) {
        this.selectedObject.metadata.keywords.push(this.newMetadataKeyword.trim())
      }
      this.newMetadataKeyword = ''
    },
    removeMetadataKeyword(idx) {
      this.selectedObject.metadata.keywords.splice(idx, 1)
    },
    deleteSelectedObjects() {
      this.pushUndoStack()
      this.selectedObjects.forEach(id => {
        const idx = this.pdfObjects.findIndex(obj => obj.id === id)
        if (idx !== -1) this.pdfObjects.splice(idx, 1)
      })
      this.selectedObjects = []
      this.filterObjects()
    },
    mergeSelectedObjects() {
      if (this.selectedObjects.length < 2) return
      this.pushUndoStack()
      const baseId = this.selectedObjects[0]
      const baseObj = this.pdfObjects.find(obj => obj.id === baseId)
      if (!baseObj) return
      for (let i = 1; i < this.selectedObjects.length; i++) {
        const mergeId = this.selectedObjects[i]
        const mergeObj = this.pdfObjects.find(obj => obj.id === mergeId)
        if (mergeObj) {
          baseObj.references = [...new Set([...baseObj.references, ...mergeObj.references])]
          baseObj.dictKeys = [...new Set([...baseObj.dictKeys, ...mergeObj.dictKeys])]
          baseObj.streamData += `\n${mergeObj.streamData}`
          baseObj.metadata.keywords = [
            ...new Set([...baseObj.metadata.keywords, ...mergeObj.metadata.keywords])
          ]
          if (mergeObj.metadata.tags && mergeObj.metadata.tags.length) {
            if (!baseObj.metadata.tags) {
              baseObj.metadata.tags = []
            }
            baseObj.metadata.tags = [
              ...new Set([...baseObj.metadata.tags, ...mergeObj.metadata.tags])
            ]
          }
        }
      }
      this.selectedObjects.forEach((id, index) => {
        if (index > 0) {
          const idx = this.pdfObjects.findIndex(obj => obj.id === id)
          if (idx !== -1) this.pdfObjects.splice(idx, 1)
        }
      })
      this.selectedObjects = []
      this.filterObjects()
      alert('Objects merged (demo).')
    },
    renameSelectedReferences() {
      if (!this.oldRef || !this.newRef) return
      this.pushUndoStack()
      this.selectedObjects.forEach(id => {
        const obj = this.pdfObjects.find(o => o.id === id)
        if (obj) {
          obj.references = obj.references.map(r => {
            if (r === this.oldRef) return this.newRef
            return r
          })
        }
      })
      this.filterObjects()
      alert('References renamed (demo).')
      this.oldRef = ''
      this.newRef = ''
    },
    exportSelectedObjectsAsJSON() {
      const exportData = this.pdfObjects.filter(obj => this.selectedObjects.includes(obj.id))
      const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(exportData, null, 2))
      const dlAnchor = document.createElement('a')
      dlAnchor.setAttribute("href", dataStr)
      dlAnchor.setAttribute("download", "pdf_objects.json")
      dlAnchor.click()
    },
    importSelectedObjectsJSON() {
      const fileInput = document.createElement('input')
      fileInput.type = 'file'
      fileInput.accept = '.json'
      fileInput.onchange = (e) => {
        const file = e.target.files[0]
        if (!file) return
        const reader = new FileReader()
        reader.onload = () => {
          try {
            const importedData = JSON.parse(reader.result)
            if (Array.isArray(importedData)) {
              this.pushUndoStack()
              importedData.forEach(obj => {
                if (!this.pdfObjects.find(o => o.id === obj.id)) {
                  this.pdfObjects.push(obj)
                }
              })
              this.filterObjects()
              alert('JSON imported (demo).')
            }
          } catch {
            alert('Invalid JSON file.')
          }
        }
        reader.readAsText(file)
      }
      fileInput.click()
    },
    toggleAISummary() {
      this.showAISummary = !this.showAISummary
    },
    generateAISummary() {
      if (!this.selectedObject) return
      this.aiSummary = `AI Summary: Object ${this.selectedObject.id} is a "${this.selectedObject.type}" with references: ${this.selectedObject.references.join(', ')}.`
    },
    aiClassifyType(item) {
      this.pushUndoStack()
      const classification = this.getRandomType()
      const idx = this.pdfObjects.findIndex(obj => obj.id === item.id)
      if (idx !== -1) {
        this.pdfObjects[idx].type = classification
      }
      this.filterObjects()
      alert(`AI reclassified object ${item.id} as "${classification}" (demo).`)
    },
    aiBatchReclassify() {
      if (!this.selectedObjects.length) return
      this.pushUndoStack()
      this.selectedObjects.forEach(id => {
        const idx = this.pdfObjects.findIndex(obj => obj.id === id)
        if (idx !== -1) {
          this.pdfObjects[idx].type = this.getRandomType()
        }
      })
      this.filterObjects()
      alert('Batch AI reclassification complete (demo).')
    },
    getRandomType() {
      const types = ['Page', 'Font', 'Annotation', 'Image', 'Outline', 'Form', 'EmbeddedFile', 'JavaScript', 'XObject', 'Shading']
      return types[Math.floor(Math.random() * types.length)]
    },
    expandAllNodes() {
      this.expandedStructure.forEach(node => {
        node.expanded = true
        if (node.children) {
          node.children.forEach(child => {
            if (child.children) child.expanded = true
          })
        }
      })
    },
    collapseAllNodes() {
      this.expandedStructure.forEach(node => {
        node.expanded = false
        if (node.children) {
          node.children.forEach(child => {
            if (child.children) child.expanded = false
          })
        }
      })
    },
    compareCandidate(item) {
      if (this.compareObjects.length < 2) {
        if (!this.compareObjects.find(o => o.id === item.id)) {
          this.compareObjects.push(JSON.parse(JSON.stringify(item)))
        }
      }
    },
    clearCompare() {
      this.compareObjects = []
    },
    selectAllObjects() {
      this.selectedObjects = this.filteredPdfObjects.map(o => o.id)
    },
    deselectAllObjects() {
      this.selectedObjects = []
    },
    saveVersion() {
      const versionData = JSON.parse(JSON.stringify(this.pdfObjects))
      this.versions.push({ data: versionData, timestamp: new Date().toLocaleString() })
      alert('Version saved (demo).')
    },
    revertVersion(index) {
      this.pushUndoStack()
      this.pdfObjects = JSON.parse(JSON.stringify(this.versions[index].data))
      this.filterObjects()
      alert(`Reverted to version ${index + 1} (demo).`)
    },
    batchRenameDictKeys() {
      if (!this.oldRef || !this.newRef) return
      this.pushUndoStack()
      this.selectedObjects.forEach(id => {
        const obj = this.pdfObjects.find(o => o.id === id)
        if (obj) {
          obj.dictKeys = obj.dictKeys.map(k => {
            if (k === this.oldRef) return this.newRef
            return k
          })
        }
      })
      this.filterObjects()
      alert('Dictionary keys renamed (demo).')
      this.oldRef = ''
      this.newRef = ''
    },
    moveObjectUp(id) {
      const index = this.pdfObjects.findIndex(obj => obj.id === id)
      if (index > 0) {
        this.pushUndoStack()
        const temp = this.pdfObjects[index]
        this.pdfObjects[index] = this.pdfObjects[index - 1]
        this.pdfObjects[index - 1] = temp
        this.filterObjects()
      }
    },
    moveObjectDown(id) {
      const index = this.pdfObjects.findIndex(obj => obj.id === id)
      if (index < this.pdfObjects.length - 1 && index !== -1) {
        this.pushUndoStack()
        const temp = this.pdfObjects[index]
        this.pdfObjects[index] = this.pdfObjects[index + 1]
        this.pdfObjects[index + 1] = temp
        this.filterObjects()
      }
    },
    handleDragStart(id) {
      this.draggingObjectId = id
    },
    handleDragOver(id) {
      if (this.draggingObjectId === null || this.draggingObjectId === id) return
    },
    handleDrop(id) {
      if (this.draggingObjectId === null || this.draggingObjectId === id) return
      const fromIndex = this.pdfObjects.findIndex(obj => obj.id === this.draggingObjectId)
      const toIndex = this.pdfObjects.findIndex(obj => obj.id === id)
      if (fromIndex === -1 || toIndex === -1) return
      this.pushUndoStack()
      const draggedItem = this.pdfObjects.splice(fromIndex, 1)[0]
      this.pdfObjects.splice(toIndex, 0, draggedItem)
      this.draggingObjectId = null
      this.filterObjects()
    },
    quickPreview(item) {
      alert(`Quick Preview: ${item.streamData.substring(0, 60)}...`)
    }
  }
}
</script>

<style scoped>
.video-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  margin-bottom: 1rem;
}
.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
.app-container {
  transition: background-color 0.4s, color 0.4s;
}
.dark-mode {
  background-color: #333;
  color: #eee;
}
.auto-mode {
  transition: filter 0.4s;
  filter: hue-rotate(45deg) brightness(1.05);
}
.focus-mode main > section:not(#pdf-dom-explorer) {
  display: none;
}
nav {
  display: flex;
  gap: 10px;
  padding: 10px;
  background: #f4f4f4;
  position: sticky;
  top: 0;
  z-index: 10;
  transition: background-color 0.4s;
}
.scrolled {
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
}
.dark-mode nav {
  background-color: #333;
}
a {
  color: #0055aa;
  text-decoration: none;
  font-weight: bold;
}
.dark-mode a {
  color: #87cefa;
}
main {
  padding: 1rem;
}
.section {
  margin: 20px 0;
  background-color: #fff;
  padding: 1rem;
  border-radius: 6px;
}
.dark-mode .section {
  background-color: #2a2a2a;
}
.dom-explorer-controls {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}
.dom-explorer table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1rem;
}
.dom-explorer th, .dom-explorer td {
  border: 1px solid #ccc;
  padding: 8px;
  transition: background-color 0.3s;
}
.dark-mode .dom-explorer th, .dark-mode .dom-explorer td {
  border: 1px solid #666;
}
.ref {
  display: inline-block;
  margin-right: 4px;
  background: #e2e2ff;
  padding: 2px 5px;
  border-radius: 3px;
}
.selected {
  background-color: #fff5c2;
}
.bulk-actions {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.pagination {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.object-details {
  margin-top: 20px;
  padding: 10px;
  border: 1px solid #ccc;
}
.dark-mode .object-details {
  border-color: #666;
  background-color: #444;
}
.object-actions {
  margin-top: 10px;
}
.dom-tree {
  margin-top: 20px;
  padding: 10px;
  border: 1px solid #ccc;
}
.dark-mode .dom-tree {
  border-color: #666;
  background-color: #444;
}
.dom-tree ul {
  list-style: none;
  padding-left: 20px;
}
.dom-tree-controls {
  margin-bottom: 8px;
}
.reflow-editor {
  margin-top: 20px;
  border: 1px dashed #666;
  padding: 10px;
  background-color: #fafafa;
}
.dark-mode .reflow-editor {
  background-color: #3a3a3a;
}
.in-render-editing {
  margin-top: 10px;
}
.copilot-suggestions {
  margin-top: 10px;
}
button {
  background-color: #0055aa;
  color: #fff;
  border: none;
  padding: 0.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
}
button:hover {
  opacity: 0.8;
}
.dark-mode button {
  background-color: #2196f3;
}
.row-fade-enter-active, .row-fade-leave-active {
  transition: opacity 0.3s;
}
.row-fade-enter-from, .row-fade-leave-to {
  opacity: 0;
}
.items-fade-enter-active, .items-fade-leave-active {
  transition: all 0.2s;
}
.items-fade-enter-from, .items-fade-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}
.stats-container {
  margin-bottom: 1rem;
  background: #e9f6ff;
  padding: 0.5rem;
  border-radius: 6px;
}
.bar-chart {
  display: flex;
  gap: 5px;
  align-items: flex-end;
  margin-top: 10px;
}
.bar {
  width: 30px;
  background-color: #5cb3ff;
  color: #fff;
  text-align: center;
  border-radius: 3px;
}
.ai-summary {
  margin-top: 10px;
  padding: 8px;
  background: #f0f0f0;
  border-radius: 4px;
}
.dark-mode .ai-summary {
  background-color: #555;
}
.advanced-search {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.tree-slide-enter-active,
.tree-slide-leave-active {
  transition: all 0.3s ease;
}
.tree-slide-enter-from,
.tree-slide-leave-to {
  height: 0;
  opacity: 0;
}
.relationship-graph {
  margin-top: 20px;
  padding: 10px;
  background: #f8f8f8;
  border: 1px solid #ccc;
}
.dark-mode .relationship-graph {
  background-color: #444;
  border-color: #666;
}
.compare-panel {
  margin-top: 20px;
  padding: 10px;
  border: 2px dashed #666;
  background-color: #fff5f5;
}
.compare-diffs {
  margin-top: 10px;
}
.versions-panel {
  margin-top: 20px;
  padding: 10px;
  background-color: #e9f6ff;
  border: 1px solid #ccc;
  border-radius: 6px;
}
.pinned-objects {
  margin-bottom: 1rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 0.5rem;
  background: #fff9e6;
}
.dark-mode .pinned-objects {
  background-color: #555;
  border-color: #666;
}
.pinned-objects table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 0.5rem;
}
.pinned-objects th,
.pinned-objects td {
  border: 1px solid #ccc;
  padding: 0.5rem;
}
.dark-mode .pinned-objects th,
.dark-mode .pinned-objects td {
  border: 1px solid #666;
}
.pdf-preview-container {
  margin-top: 20px;
  border: 1px solid #ddd;
  padding: 10px;
  background-color: #fafafa;
}
.preview-canvas {
  margin-top: 10px;
  height: 300px;
  background-color: #fff;
  border: 1px solid #ccc;
}
.type-page {
  background-color: #e0f7e0;
}
.type-font {
  background-color: #fffde0;
}
.type-annotation {
  background-color: #ffe0f5;
}
.type-image {
  background-color: #e0f0ff;
}
.type-outline {
  background-color: #f5e0ff;
}
.type-form {
  background-color: #f0e0ff;
}
.minimap {
  position: fixed;
  right: 0;
  top: 60px;
  width: 200px;
  background: #fafafa;
  border: 1px solid #ccc;
  max-height: 400px;
  overflow-y: auto;
  padding: 10px;
}
.minimap h4 {
  margin-top: 0;
}
.map-page {
  color: green;
}
.map-font {
  color: goldenrod;
}
.map-annotation {
  color: hotpink;
}
.map-image {
  color: dodgerblue;
}
.map-outline {
  color: purple;
}
.map-form {
  color: teal;
}
img {
  max-width: 600px;
  max-height: 600px;
  width: auto;
  height: auto;
}
</style>

<style>
body {
  margin: 0;
  font-family: Arial, sans-serif;
  background-color: #f3f3f3;
  color: #333;
}
.dark-mode {
  background-color: #1e1e1e;
  color: #f0f0f0;
}
main {
  padding: 1rem;
}
.section {
  background-color: #fff;
  margin: 1rem 0;
  padding: 1rem;
  border-radius: 6px;
}
.dark-mode .section {
  background-color: #2a2a2a;
}
button {
  background-color: #0055aa;
  color: #fff;
  border: none;
  padding: 0.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
}
.dark-mode button {
  background-color: #2196f3;
}
button:hover {
  opacity: 0.8;
}
a {
  color: #0055aa;
  text-decoration: none;
  font-weight: bold;
}
.dark-mode a {
  color: #87cefa;
}
textarea {
  width: 100%;
  margin-top: 0.5rem;
}
</style>